/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { getSoldStatusByNFTTokenID } from "../blockchain/web3.service"

export const useNFTSoldStatus = (props) => {

  const { tokenID } = props
  const [isSold, setIsSold] = useState(false)
  const [isLoading, setLoading] = useState(false)

  useEffect(() => {
    if (tokenID) {
      fetchNFTSoldStatus()
    }
  }, [tokenID])

  const fetchNFTSoldStatus = async () => {
    try {
      setLoading(true)
      const soldStatusResponse = await getSoldStatusByNFTTokenID(tokenID)
      setIsSold(soldStatusResponse)
    } catch (error) {
      setIsSold(false)
      console.error('error while fetching nft minted status from hook ', error)
    } finally {
      setLoading(false)
    }
  }
  return { isSold, isLoading }
}

export default useNFTSoldStatus

